import { Action, combineReducers, createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromDomain from '../domain/reducers/domain.reducer';
import * as fromSubscription from '../subscription/reducers/subscription.reducer';

export const signupFeatureKey = 'signup';

export interface SignupState {
    [fromDomain.domainFeatureKey]: fromDomain.State;
    [fromSubscription.subscriptionFeatureKey]: fromSubscription.State;
}

export interface State {
    [signupFeatureKey]: SignupState;
}

export function reducers(state: SignupState | undefined, action: Action) {
    return combineReducers({
        [fromDomain.domainFeatureKey]: fromDomain.reducer,
        [fromSubscription.subscriptionFeatureKey]: fromSubscription.reducer,
    })(state, action);
}

export const getSignupState = createFeatureSelector< SignupState>(
    signupFeatureKey
);

export const getDomainEntitiesState = createSelector(
    getSignupState,
    state => state.domain
);

export const getSubscriptionEntitiesState = createSelector(
    getSignupState,
    state => state.subscription
);

export const getDomainToCreate = createSelector(
    getDomainEntitiesState,
    fromDomain.getDomainToCreate
);

export const getDomainCreated = createSelector(
    getDomainEntitiesState,
    fromDomain.getDomainCreated
);

export const getTeamCreated = createSelector(
    getDomainEntitiesState,
    fromDomain.getTeamCreated
);

export const getDomainError = createSelector(
    getDomainEntitiesState,
    fromDomain.getDomainError
);

export const getDomainCreationFailed = createSelector(
    getDomainEntitiesState,
    fromDomain.getDomainCreationFailed
);

export const getPlans = createSelector(
    getSubscriptionEntitiesState,
    fromSubscription.getPlans,
);

export const getComputedPlan = createSelector(
    getSubscriptionEntitiesState,
    fromSubscription.getComputedPlan,
);

export const getFormData = createSelector(
    getSubscriptionEntitiesState,
    fromSubscription.getFormData,
);

export const getUpdateAccountProcessing = createSelector(
    getSubscriptionEntitiesState,
    fromSubscription.getUpdateAccountProcessing,
);

export const getUpdateAccountSucceed = createSelector(
    getSubscriptionEntitiesState,
    fromSubscription.getUpdateAccountSucceed,
);

export const getUpdateAccountFailed = createSelector(
    getSubscriptionEntitiesState,
    fromSubscription.getUpdateAccountFailed,
);

export const getUpdateSubscriptionProcessing = createSelector(
    getSubscriptionEntitiesState,
    fromSubscription.getUpdateSubscriptionProcessing,
);

export const getUpdateSubscriptionSucceed = createSelector(
    getSubscriptionEntitiesState,
    fromSubscription.getUpdateSubscriptionSucceed,
);

export const getUpdateSubscriptionFailed = createSelector(
    getSubscriptionEntitiesState,
    fromSubscription.getUpdateSubscriptionFailed,
);

export const getUpdateBillingInformationsProcessing = createSelector(
    getSubscriptionEntitiesState,
    fromSubscription.getUpdateBillingInformationsProcessing,
);

export const getUpdateBillingInformationsSucceed = createSelector(
    getSubscriptionEntitiesState,
    fromSubscription.getUpdateBillingInformationsSucceed,
);

export const getUpdateBillingInformationsFailed = createSelector(
    getSubscriptionEntitiesState,
    fromSubscription.getUpdateBillingInformationsFailed,
);

export const getUpdateBillingInformationsError = createSelector(
    getSubscriptionEntitiesState,
    fromSubscription.getUpdateBillingInformationsError,
);

export const getSignupProcessing = createSelector(
    getSubscriptionEntitiesState,
    fromSubscription.getSignupProcessing,
);

export const getSignupSucceed = createSelector(
    getSubscriptionEntitiesState,
    fromSubscription.getSignupSucceed,
);

export const getSignupFailed = createSelector(
    getSubscriptionEntitiesState,
    fromSubscription.getSignupFailed,
);

export const getSignupError = createSelector(
    getSubscriptionEntitiesState,
    fromSubscription.getSignupError,
);

export const getPlanGroupLoaded = createSelector(
    getSubscriptionEntitiesState,
    fromSubscription.getPlanGroupLoaded,
);
